module.exports = __webpack_public_path__ + "wsegar-headshot.jpg?6d64c13596420fdf69af57f81eece444";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headshots/wsegar-headshot.jpg
// module id = 39
// module chunks = 0